import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js'
import { AWS_USER_POOL_APP_CLIENT_ID, AWS_USER_POOL_ID } from 'src/utils/Constants'

const poolData = {
  UserPoolId: AWS_USER_POOL_ID!,
  ClientId: AWS_USER_POOL_APP_CLIENT_ID!,
}
const userPool = new CognitoUserPool(poolData)
const flowType = 'USER_PASSWORD_AUTH'
let cognitoUser: CognitoUser | null = null

// Functions ------------

const getAccessToken = async (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const cognitoUser = userPool.getCurrentUser()

    if (!cognitoUser) {
      reject(new Error('No user'))
      return
    }

    cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (!session) {
        reject(err)
      } else {
        resolve(session.getIdToken().getJwtToken())
      }
    })
  })
}

const hasEmailAddress = (): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const cognitoUser = userPool.getCurrentUser()
    if (!cognitoUser) return reject(new Error('No user'))

    cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (!session) return reject(err)

      // ユーザー属性を取得
      cognitoUser.getUserAttributes((err, attributes) => {
        if (err) return reject(err)

        const emailAttribute = attributes?.find((attr) => attr.getName() === 'email')

        // 3. メアドが設定されているかチェック
        resolve(!!emailAttribute?.getValue())
      })
    })
  })
}

const logIn = (userName: string, password: string): Promise<{ isTemporary: boolean; data: any }> => {
  return new Promise((resolve, reject) => {
    const details = new AuthenticationDetails({
      Username: userName,
      Password: password,
    })
    cognitoUser = new CognitoUser({
      Username: userName,
      Pool: userPool,
    })
    cognitoUser.setAuthenticationFlowType(flowType)
    cognitoUser.authenticateUser(details, {
      onSuccess: (result) => resolve({ isTemporary: false, data: result.getIdToken().getJwtToken() }),
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => {
        delete userAttributes.email_verified
        delete userAttributes.email

        resolve({ isTemporary: true, data: userAttributes })
      },
    })
  })
}

const logOut = (): void => {
  userPool.getCurrentUser()?.signOut()
}

const changePassword = (currentPassword: string, newPassword: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const cognitoUser = userPool.getCurrentUser()

    if (!cognitoUser) {
      reject(new Error('No user'))
      return
    }

    cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (!session) {
        reject(err)
        return
      }

      cognitoUser.changePassword(currentPassword, newPassword, (error, result) => {
        if (error || !result) {
          reject(error || new Error('Failed'))
          return
        }

        resolve()
      })
    })
  })
}

const changeTemporaryPassword = (newPassword: string, userAttributes: any): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!cognitoUser) {
      reject(new Error('No user'))
      return
    }

    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: () => resolve(),
      onFailure: (err) => reject(err),
    })
  })
}

const resetPassword = (usercode: string) => {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: usercode,
      Pool: userPool,
    })

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        console.log(data)
        resolve(data)
      },
      onFailure: (err) => {
        console.log(err)
        reject(err)
      },
    })
  })
}

const Cognito = {
  getAccessToken,
  hasEmailAddress,
  logIn,
  logOut,
  changePassword,
  resetPassword,
  changeTemporaryPassword,
}
export default Cognito
